// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__1uhUL","content__title":"Content_content__title__3GDA3","content__description":"Content_content__description__12bzf"};